export enum TaxType {
  NoTax = 0,
  UKVAT = 1,
  USSalesTax = 2,
}
